/** Resume site branding — Amirreza Dehghani */
export const DEFAULT_BRAND_NAME = "امیررضا دهقانی";
export const DEFAULT_SITE_TITLE = "امیررضا دهقانی | رزومه";

export function displayBrandName(name) {
  const n = (name || "").trim();
  if (!n) return DEFAULT_BRAND_NAME;
  const lower = n.toLowerCase();
  if (lower === "portfolio" || n === "پورتفولیو") return DEFAULT_BRAND_NAME;
  return n;
}
